// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__3TCBG","header":"Accordion_header__mSY7d","icon":"Accordion_icon__Dasp1","active":"Accordion_active__szzt+","content":"Accordion_content__dTX7p"};